// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2xqyN","detailsBorder":"styles_detailsBorder__3GMW-"};